var app = angular.module('leonardo');

var OnDemandCategoryService = function(BaseRestService, RestangularProvider) {
  var service = new BaseRestService('on-demand-categories', function(RestangularConfigurer) {
    RestangularConfigurer.addElementTransformer('on-demand-categories', false, function(instruction) {
      instruction.addRestangularMethod('cloneToWhiteLabel', 'post', 'clone-to-whitelabel');
      return instruction;
    });
  });

  service.bulkObject = function() {
    return {
      name: '',
      image: null,
      description: ''
    };
  };


  return service;
};

app.factory('OnDemandCategoryService', ['BaseRestService', 'Restangular', OnDemandCategoryService]);
